<template>
  <div>
    <div class="left-one">
      <div class="title">{{ title }}</div>
      <div
        style="
          position: absolute;
          width: 290px;
          height: 80px;
          top: 17px;
          left: -16px;
        "
      >
        <img :src="biaoti" alt="" style="width: 100%; height: 100%" />
      </div>
      <img class="back_img" :src="back" alt="" @click="handleBack" />
    </div>
    <el-menu
      :default-active="activeMenu"
      :collapse="false"
      :unique-opened="true"
      :background-color="'#F6F6F6'"
      :text-color="'#333333'"
      :active-text-color="'#c02c38'"
      mode="vertical"
    >
      <sidebar-item
        v-for="route in routes"
        :key="route.path"
        :item="route"
        :base-path="route.path"
      />
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import biaoti from '@/assets/homePage/titleBg.png'
import back from '@/assets/homePage/backNew.png'
import SidebarItem from './SidebarItem.vue'
export default {
  data () {
    return {
      biaoti: biaoti,
      back: back
    }
  },
  created () {
  },
  methods: {
    handleBack () {
      this.$router.push('/')
      this.$store.dispatch('topBar/setMenuCode', 'SY')
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'addRoutes', 'MenuCode']),
    routes () {
      return this.$router.options.routes.concat(this.addRoutes)
    },
    title () {
      return sessionStorage.getItem('title') || ''
    },
    activeMenu () {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    }
  },
  watch: {
  },
  components: {
    SidebarItem
  }
}
</script>

<style lang="less" scoped>
.item {
  width: 247px;
  color: #333333;
  height: 66px;
  text-align: center;
  line-height: 66px;
  font-size: 16px;
  cursor: pointer;
}
.active {
  background: #e8e8e8;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #c02c38;
  line-height: 66px;
}
.title {
  margin-right: 20px;
  font-family: PingFangSC-Medium;
  color: #C02C38;
  font-weight: bold;
  font-size: 18px;
  position: relative;
  z-index: 1;
}
.back_img {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 43px;
  left: 50px;
  z-index: 2;
  cursor: pointer;
}
/deep/ .el-menu {
  justify-content: center;
}
/deep/ .el-menu a {
  text-decoration: none;
}
/deep/ .el-menu .el-submenu__title span {
  font-size: 16px;
  font-weight: bold;
  font-family: PingFang SC;
  margin-left: 50px;
}
/deep/ .el-menu span {
  font-size: 15px;
  // font-weight: bold;
  // font-family: Source Han Sans CN;
  margin-left: 50px;
}
/deep/ .el-menu-item.is-active{
//设置背景颜色
  background-color: #e8e8e8 !important;
}
</style>
